import { render, staticRenderFns } from "./ApplyRule.vue?vue&type=template&id=2253c18e"
import script from "./ApplyRule.vue?vue&type=script&lang=js"
export * from "./ApplyRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports